<h1>Inscrição</h1>

<mat-card class="info">
  <p>Atenção</p>
  <ul>
    <li>
      Seleciona o período letivo, a unidade e o departamento; clique no botão selecionar da disciplina que deseja se
      inscrever.
    </li>
    <li>
      Caso não encontre a unidade, o departamento ou a disciplina por favor aguarde a liberação pelo departamento de
      ensino.
    </li>
  </ul>
</mat-card>
<br />

<div fxLayout="column">
  <mat-form-field appearance="outline">
    <mat-label>Período Letivo</mat-label>
    <mat-select [(value)]="anoSelecionado" (selectionChange)="getUnidade()">
      <mat-option *ngFor="let ano of anos" [value]="ano">
        {{ ano }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Unidade</mat-label>
    <mat-select [(value)]="idUnidadeUniversitaria" (selectionChange)="getDepartamento()">
      <mat-option *ngFor="let unidade of unidades" [value]="unidade.id">
        {{ unidade.campus }} - {{ unidade.sigla }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Departamento</mat-label>
    <mat-select [(value)]="idDepartamentoSecao" (selectionChange)="getData()">
      <mat-option *ngFor="let departamento of departamentos" [value]="departamento.id">
        {{ departamento.nome }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<mat-form-field appearance="outline" fxFill>
  <mat-icon matPrefix>search</mat-icon>
  <mat-label>Pesquisar</mat-label>
  <input matInput type="search" (keyup)="search($event)" placeholder="" #input />
</mat-form-field>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
      <td mat-cell data-label="#" *matCellDef="let row">{{ row.id }}</td>
    </ng-container>
    <ng-container matColumnDef="nomeDisciplina">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Disciplina</th>
      <td mat-cell data-label="Disciplina" *matCellDef="let row">{{ row.nomeDisciplina }}</td>
    </ng-container>
    <ng-container matColumnDef="codigoDisciplina">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
      <td mat-cell data-label="Código" *matCellDef="let row">{{ row.codigoDisciplina }}</td>
    </ng-container>
    <ng-container matColumnDef="duracao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Duração</th>
      <td mat-cell data-label="Duração" *matCellDef="let row">{{ row.duracao }}</td>
    </ng-container>
    <ng-container matColumnDef="cargaHoraria">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Carga Horária</th>
      <td mat-cell data-label="Carga horária" *matCellDef="let row">{{ row.cargaHoraria }}</td>
    </ng-container>
    <ng-container matColumnDef="semestre">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Semestre</th>
      <td mat-cell data-label="Semestre" *matCellDef="let row">{{ row.semestre }}</td>
    </ng-container>
    <ng-container matColumnDef="selecionado">
      <th mat-header-cell *matHeaderCellDef>Selecionar</th>
      <td mat-cell data-label="Selecionar" *matCellDef="let row">
        <mat-checkbox (change)="mudarSelecao(row)" [checked]="row.selecionado"> </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
    <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="7">
        <span *ngIf="input.value">Nenhum registro encontrado para a pesquisa: "{{ input.value }}"</span>
        <span *ngIf="!input.value">Nenhum registro disponível</span>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
</div>
